import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const RecallScheduling = ({ recallSchedule, planId, getStatusColor }) => {
  const [showAddRecall, setShowAddRecall] = useState(false);

  const recallTypes = [
    { value: '6-month-cleaning', label: '6-Month Cleaning', defaultInterval: '6 months' },
    { value: 'annual-xrays', label: 'Annual X-rays', defaultInterval: '12 months' },
    { value: '3-month-perio', label: '3-Month Perio Maintenance', defaultInterval: '3 months' },
    { value: 'implant-followup', label: 'Implant Follow-up', defaultInterval: '3 months' },
    { value: 'crown-check', label: 'Crown/Bridge Check', defaultInterval: '6 months' },
    { value: 'ortho-adjustment', label: 'Orthodontic Adjustment', defaultInterval: '4 weeks' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="Bell" size={16} className="text-primary" />
          Automated Recall Schedule
        </h3>
        <button onClick={() => setShowAddRecall(!showAddRecall)}>
          <Icon name={showAddRecall ? 'X' : 'Plus'} size={16} className="text-muted-foreground" />
        </button>
      </div>

      {showAddRecall && (
        <div className="mb-4 p-3 bg-muted/50 rounded-lg">
          <p className="text-xs font-medium text-foreground mb-2">Add Recall Appointment</p>
          <select className="w-full p-2 bg-background border border-border rounded text-sm text-foreground mb-2">
            <option value="">Select recall type...</option>
            {recallTypes?.map((type) => (
              <option key={type?.value} value={type?.value}>
                {type?.label} ({type?.defaultInterval})
              </option>
            ))}
          </select>
          <div className="flex items-center gap-2">
            <Button variant="default" size="xs" iconName="Plus">
              Add
            </Button>
            <Button variant="ghost" size="xs" onClick={() => setShowAddRecall(false)}>
              Cancel
            </Button>
          </div>
        </div>
      )}

      <div className="space-y-2">
        {recallSchedule?.map((recall, idx) => (
          <div key={idx} className="p-3 bg-background rounded-lg border border-border">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">{recall?.type}</p>
                <p className="text-xs text-muted-foreground">Due: {recall?.dueDate}</p>
              </div>
              <span className={cn(
                "text-xs px-2 py-1 rounded border",
                getStatusColor(recall?.status)
              )}>
                {recall?.status}
              </span>
            </div>
            
            <div className="flex items-center gap-2">
              {recall?.notificationSent ? (
                <div className="flex items-center gap-1 text-xs text-success">
                  <Icon name="CheckCircle" size={12} />
                  <span>Notification sent</span>
                </div>
              ) : (
                <Button variant="ghost" size="xs" iconName="Send">
                  Send Reminder
                </Button>
              )}
              <Button variant="ghost" size="xs" iconName="Calendar">
                Schedule
              </Button>
            </div>
          </div>
        ))}
      </div>

      {recallSchedule?.length === 0 && (
        <div className="text-center py-6">
          <Icon name="Calendar" size={32} className="text-muted-foreground mx-auto mb-2" />
          <p className="text-xs text-muted-foreground">No recall appointments scheduled</p>
        </div>
      )}

      <div className="mt-4 p-3 bg-primary/5 rounded-lg">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={14} className="text-primary mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            Automated reminders will be sent 2 weeks before due date via email and SMS
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecallScheduling;